import {Suspense} from "react";
import {Helmet} from "react-helmet-async";

import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {LoadingContainer} from "@/components/placeholder/LoadingContainer.tsx";
import {ErrorFallback} from "@/lib/handlers/ErrorFallback.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {CreateStatusPageForm} from "@/pages/statuspages/statuspages-create/CreateStatusPageForm.tsx";

export const CreateStatuspagePage = () => {
  return (
    <UpErrorBoundary
      fallback={
        <ContentContainer title={"Create New Status Page"}>
          <ErrorFallback />
        </ContentContainer>
      }
    >
      <Helmet>
        <title>Create New Status Page</title>
      </Helmet>
      <Suspense fallback={<LoadingContainer />}>
        <CreateStatusPageForm />
      </Suspense>
    </UpErrorBoundary>
  );
};
